import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deviceSummary, publicSummary, summary } from "../modules/result";
import { check, setDomainNames } from "../modules/auth";
import ResultForm from "../components/ResultForm";
import { withRouter } from "react-router-dom";
import { changeField } from "../modules/modal";

const ResultContainer = ({ token, history }) => {
  const dispatch = useDispatch();
  const {
    solved_problems,
    achieve,
    public_result_table,
    result_table,
    auth,
    authError,
    domainNames,
    popupState,
    reviewed,
  } = useSelector(({ problem, result, auth, modal }) => ({
    solved_problems: problem.solved_problems,
    achieve: result.achievement,
    public_result_table: result.publicSummary,
    result_table: result.summary,
    auth: auth.auth,
    authError: auth.authError,
    domainNames: auth.domainNames,
    popupState: modal.popupState,
    reviewed: modal.success,
  }));
  const [clickLock, setClickLock] = useState(false);
  const [achieveLoading, setAchieveLoading] = useState(true);
  const [isPublic, setIsPublic] = useState(false);

  /*
   * start page처럼 result page도 단일로 외부에서 재호출이 일어남
   * 따라서 reuslt page도 단일로 접근이 가능하게 구현해야함
   *
   * 단일로 접근했을 때 result page의 URL에 파라미터로 token을 전달받았다면
   * publicSummary를 통해 token을 해독해 결과보기 페이지를 구성한다.
   * 이때 isPublic state를 통해 외부 접근임을 추적한다.
   *
   * 만약 result page의 URL에 token 파라미터가 없어도 학습기에서 직전 학습 결과를 보는 경우가 발생할 수 있다.
   * 이때는 학습기 window.Android.getInitVariables() 객체에서 userId를 참조해 diag_t_id에 대입하고 deviceSummary() 메소드를 호출하고 isPublic state를 true로 한다.
   * deviceSummary() 메소드는 diagnosis_reg 테이블에서 diag_t_id로 쿼리해 가장 최신의 로우를 가지고 구성한 public_result_table을 응답한다.
   *
   * 만약 진단검사의 플로우대로 결과페이지에 도착했을 때는
   * 인증 정보가 쿠키스토어에 있을 것이므로 인증 정보를 check() 메소드로 검증한다.
   */
  useEffect(() => {
    if (token) {
      dispatch(publicSummary({ token }));
      setIsPublic(true);
    } else {
      if (window.Android) {
        const variables = JSON.parse(window.Android.getInitVariables());
        if ("diag_token" in variables === false) {
          const diag_t_id = variables["userId"];
          dispatch(deviceSummary({ diag_t_id }));
          setIsPublic(true);
        } else {
          dispatch(check());
        }
      } else {
        dispatch(check());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*
   * publicSummary() / deviceSummary() 메소드는 public_result_table을 응답한다.
   * public_reuslt_table이 있다는 것은 정상적인 진단평가 플로우대로 동작한게 아니라는 뜻이다.
   * domainNames도 설정이 안되어있을 것이므로 domainNames를 설정해준다.
   */
  useEffect(() => {
    if (Object.keys(public_result_table).length) {
      let domainNames = [];
      const grade = parseInt(public_result_table.grade);
      const st_month = parseInt(public_result_table.st_month);
      if (grade >= 7) {
        domainNames = [
          ["수와 연산", "수와 연산"],
          ["문자와 식", "측정"],
          ["함수", "규칙성"],
          ["기하", "도형"],
          ["확률과 통계", "자료와 가능성"],
        ];
        if (grade === 7 && st_month <= 5) {
          domainNames[1] = ["측정", "측정"];
        }
      } else {
        domainNames = [
          ["수와 연산", "수와 연산"],
          ["도형", "도형"],
          ["측정", "측정"],
          ["규칙성", "규칙성"],
          ["자료와 가능성", "자료와 가능성"],
        ];
      }
      dispatch(setDomainNames(domainNames));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [public_result_table]);

  useEffect(() => {
    if (authError) {
      return;
    } else if (auth) {
    } else if (window.Android) {
    }
  }, [auth, authError]);

  /*
   * 만약 진단평가의 플로우를 따라왔다면 solved_problems 객체가 존재할 것이다.
   * solved_problems 객체와 achieve 객체를 파라미터로 sumamry() 메소드를 호출해 result_table을 응답받늗나.
   */
  useEffect(() => {
    if (solved_problems.length && achieveLoading) {
      /*
      dispatch(
        achievement({ solved_problems: solved_problems, achieve: achieve })
      );
      */
      dispatch(summary({ solved_problems: solved_problems, achieve: achieve }));
      setAchieveLoading(false);
      //console.log(result_table);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solved_problems]);

  /*
   * 하단 버튼을 클릭했을 때 모달 팝업의 호출을 다루는 메소드
   * popupState의 값에 따라 모달 팝업을 다루는 Modal Container의 동작이 달라짐
   * 즉 모달 팝업의 팝업 여부가 달라짐
   */
  const onClick = () => {
    if (!clickLock && !reviewed) {
      setClickLock(true);
      dispatch(changeField({ key: "popupState", value: true }));
      setClickLock(false);
    }
  };

  const ooResultPaperClick = (e) => {
    e.preventDefault();
    history.push(`/diagnosis/resultpaper/${token}`);
  };
  

  /*
   * isPublic state는 하단의 모달팝업 버튼의 출력 여부를 담당함
   * public_reuslt_table이냐, result_table이냐에 따라서 결과보기 페이지의 파라미터가 조금 달라짐
   */
  return auth ? (
    Object.keys(result_table).length === 0 ? (
      <p>no</p>
    ) : (
      <ResultForm
        result_table={result_table}
        achieve={achieve}
        st_grade={auth.grade}
        domainNames={domainNames}
        name={auth.name}
        start_dt={auth.start_dt}
        t_type={auth.t_type}
        popupState={popupState}
        onClick={onClick}
      ></ResultForm>
    )
  ) : Object.keys(public_result_table).length === 0 ? (
    <p>no</p>
  ) : (
    <ResultForm
      result_table={public_result_table.result_table}
      achieve={public_result_table.achievement}
      st_grade={public_result_table.grade}
      domainNames={domainNames}
      name={public_result_table.name}
      start_dt={public_result_table.start_dt}
      t_type={public_result_table.t_type}
      isPublic={isPublic}
      ooResultPaperClick={ooResultPaperClick}
    ></ResultForm>
  );
};

export default withRouter(ResultContainer);
